module.exports = __webpack_public_path__ + "media/images/lb/962-9292533d092bcf5d0381a0349a6768b5.svg";